import TransactionHistory from "@adapters/presenters/Reports/TransactionHistory";
export default (useCases, actions) => {
    return {
        transactionHistory: new TransactionHistory(actions, useCases, useCases.sendEmailReports, useCases.downloadPDFReports, useCases.downloadExcelReports, useCases.TransactionHistoryCommonUseCase),
    };
};
